var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 167.674,
    height: 67.53,
    viewBox: "0 0 167.674 67.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.674,
    height: 67.53,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.92,58.732c0,2.939-2.3,4.654-6.712,4.654h-8.525V46.239h8.035c4.116,0,6.32,1.739,6.32,4.458a4.111,4.111,0,0,1-2.2,3.772,4.223,4.223,0,0,1,3.087,4.263m-12.052-9.995v4.728h4.507c2.2,0,3.454-.784,3.454-2.351,0-1.592-1.249-2.376-3.454-2.376Zm8.843,9.676c0-1.715-1.3-2.474-3.7-2.474h-5.144v4.948h5.144c2.4,0,3.7-.76,3.7-2.474",
    transform: "translate(-196.369 -33.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.245,53.277v7.5h-3.062v-7.1c0-2.327-1.151-3.454-3.111-3.454-2.18,0-3.65,1.323-3.65,3.944v6.614H340.36V42.6h3.062v6.614a5.831,5.831,0,0,1,4.36-1.666c3.135,0,5.463,1.788,5.463,5.732",
    transform: "translate(-244.211 -30.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.076,65.673V73.34h-2.89V71.748c-.735,1.127-2.156,1.764-4.116,1.764-2.988,0-4.875-1.641-4.875-3.92,0-2.18,1.47-3.895,5.438-3.895h3.381v-.2c0-1.788-1.078-2.842-3.258-2.842a6.479,6.479,0,0,0-3.969,1.3l-1.2-2.229a9.2,9.2,0,0,1,5.537-1.617c3.772,0,5.952,1.788,5.952,5.561m-3.062,3.577V67.731h-3.16c-2.082,0-2.646.784-2.646,1.739,0,1.1.931,1.813,2.5,1.813a3.334,3.334,0,0,0,3.307-2.033",
    transform: "translate(-285.708 -43.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.424,60.112v2.915a3.9,3.9,0,0,0-.71-.073c-2.327,0-3.8,1.372-3.8,4.042V73.34h-3.062V60.259h2.915V62.17c.882-1.372,2.474-2.058,4.654-2.058",
    transform: "translate(-327.079 -43.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.9,65.673V73.34h-2.89V71.748c-.735,1.127-2.156,1.764-4.116,1.764-2.989,0-4.875-1.641-4.875-3.92,0-2.18,1.47-3.895,5.438-3.895h3.381v-.2c0-1.788-1.078-2.842-3.258-2.842a6.479,6.479,0,0,0-3.969,1.3l-1.2-2.229a9.2,9.2,0,0,1,5.537-1.617c3.772,0,5.952,1.788,5.952,5.561m-3.062,3.577V67.731h-3.16c-2.082,0-2.646.784-2.646,1.739,0,1.1.931,1.813,2.5,1.813a3.334,3.334,0,0,0,3.307-2.033",
    transform: "translate(-351.592 -43.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.126,65.662a4.811,4.811,0,0,1-2.94.882c-2.866,0-4.508-1.519-4.508-4.409v-6.3h-2.155v-2.45h2.155V50.4h3.062v2.988h3.5v2.45h-3.5v6.222c0,1.274.637,1.959,1.812,1.959a2.752,2.752,0,0,0,1.715-.539Z",
    transform: "translate(-388.547 -36.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.346,132.418c0-5.119,3.92-8.819,9.186-8.819a8.687,8.687,0,0,1,6.786,2.866L283.26,128.4a6.022,6.022,0,0,0-4.581-2.009,6.027,6.027,0,1,0,0,12.053,5.962,5.962,0,0,0,4.581-2.033l2.058,1.96a8.7,8.7,0,0,1-6.81,2.866c-5.242,0-9.162-3.7-9.162-8.819",
    transform: "translate(-193.258 -88.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.566,143.9v7.667h-2.891v-1.592c-.735,1.127-2.156,1.764-4.116,1.764-2.988,0-4.875-1.641-4.875-3.92,0-2.18,1.47-3.895,5.438-3.895H342.5v-.2c0-1.788-1.078-2.842-3.258-2.842a6.479,6.479,0,0,0-3.969,1.3l-1.2-2.229a9.2,9.2,0,0,1,5.537-1.617c3.772,0,5.952,1.788,5.952,5.561m-3.062,3.577v-1.519h-3.16c-2.083,0-2.646.784-2.646,1.739,0,1.1.931,1.813,2.5,1.813a3.334,3.334,0,0,0,3.307-2.033",
    transform: "translate(-239.421 -99.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.915,138.34v2.915a3.9,3.9,0,0,0-.71-.073c-2.327,0-3.8,1.372-3.8,4.042v6.345h-3.062V138.487h2.915V140.4c.882-1.372,2.474-2.058,4.654-2.058",
    transform: "translate(-280.793 -99.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.954,132.461a6.372,6.372,0,0,1-6.639,6.712,5.394,5.394,0,0,1-4.336-1.862V139h-2.915V120.825h3.062v6.687a5.438,5.438,0,0,1,4.189-1.739,6.352,6.352,0,0,1,6.639,6.688m-3.111,0a3.888,3.888,0,1,0-3.871,4.091,3.8,3.8,0,0,0,3.871-4.091",
    transform: "translate(-307.856 -86.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.826,144.072v7.5h-3.062v-7.1c0-2.327-1.151-3.454-3.111-3.454-2.18,0-3.65,1.323-3.65,3.944v6.614h-3.062V138.487h2.915v1.69a5.687,5.687,0,0,1,4.507-1.837c3.136,0,5.463,1.788,5.463,5.732",
    transform: "translate(-393.151 -99.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.038,138.738a8.13,8.13,0,0,0-1.654.172,2.607,2.607,0,0,1,1.1,2.114,2.206,2.206,0,0,1-.037.354,4.377,4.377,0,0,1,.59-.044,4.1,4.1,0,1,1-3.871,4.091,4.6,4.6,0,0,1,.416-1.971,2.626,2.626,0,0,1-2.11-2.2,6.768,6.768,0,0,0,5.564,10.879c4.066,0,6.982-2.792,6.982-6.712s-2.915-6.688-6.982-6.688",
    transform: "translate(-348.766 -99.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.578,141.9a1.718,1.718,0,1,1-1.653-1.759,1.771,1.771,0,0,1,1.653,1.759",
    transform: "translate(-354.551 -100.551)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.871,154.061v2.4a.427.427,0,0,0,.213.369l2.082,1.2a.426.426,0,0,0,.427,0l2.083-1.2a.427.427,0,0,0,.213-.369v-2.4a.426.426,0,0,0-.213-.369l-2.083-1.2a.428.428,0,0,0-.427,0l-2.082,1.2a.426.426,0,0,0-.213.369",
    transform: "translate(-360.096 -109.371)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.762,205.986a3.722,3.722,0,0,1,.06-7.443,3.722,3.722,0,1,1-.06,7.443",
    transform: "translate(-94.087 -142.456)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,202.152a3.723,3.723,0,0,1-3.707,3.75,3.732,3.732,0,0,1-.036-7.464,3.712,3.712,0,0,1,3.743,3.713",
    transform: "translate(-58.61 -142.381)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.408,42.866a3.71,3.71,0,0,1-7.419.112,3.71,3.71,0,1,1,7.419-.112",
    transform: "translate(-124.838 -28.11)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.457,181.366a3.69,3.69,0,0,1-3.654-3.794,3.7,3.7,0,0,1,7.408.113,3.669,3.669,0,0,1-3.755,3.681",
    transform: "translate(-124.705 -124.806)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1,177.324a3.648,3.648,0,0,1,3.9-3.515,3.7,3.7,0,0,1-.359,7.391,3.647,3.647,0,0,1-3.542-3.876",
    transform: "translate(-28.053 -124.706)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.935,134.963a3.735,3.735,0,1,1-3.821-3.645,3.765,3.765,0,0,1,3.821,3.645",
    transform: "translate(-142.401 -94.221)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.733,18.253a3.706,3.706,0,1,1-3.672-3.767,3.687,3.687,0,0,1,3.672,3.767",
    transform: "translate(-94.224 -10.394)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.049,39.062a3.7,3.7,0,0,1-.094,7.391,3.7,3.7,0,1,1,.094-7.391",
    transform: "translate(-28.175 -28.027)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,85.643a3.75,3.75,0,0,1-3.784,3.656,3.7,3.7,0,0,1-3.655-3.775,3.72,3.72,0,1,1,7.439.119",
    transform: "translate(-142.504 -58.728)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.711,14.425a3.706,3.706,0,0,1,3.659,3.789,3.724,3.724,0,0,1-7.446-.131,3.7,3.7,0,0,1,3.787-3.658",
    transform: "translate(-58.781 -10.349)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.159,131.066a3.694,3.694,0,0,1,3.687,3.765,3.722,3.722,0,1,1-7.441-.2,3.693,3.693,0,0,1,3.755-3.562",
    transform: "translate(-10.334 -94.041)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.153,89.079a3.678,3.678,0,0,1-3.664-3.771,3.715,3.715,0,1,1,3.664,3.771",
    transform: "translate(-10.396 -58.6)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,205.548a3.155,3.155,0,0,1-3.253,3.042A3.15,3.15,0,1,1,169,205.548",
    transform: "translate(-116.76 -145.145)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.756,49.073a3.143,3.143,0,1,1,3.126-3.183,3.114,3.114,0,0,1-3.126,3.183",
    transform: "translate(-50.677 -30.7)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.321,73.661a3.146,3.146,0,0,1-6.291-.006,3.146,3.146,0,0,1,6.291.006",
    transform: "translate(-124.867 -50.596)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.618,177.115a3.131,3.131,0,0,1-6.261.062,3.165,3.165,0,0,1,3.106-3.218,3.122,3.122,0,0,1,3.154,3.156",
    transform: "translate(-105.013 -124.817)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.721,173.985a3.148,3.148,0,1,1-3.111,3.2,3.123,3.123,0,0,1,3.111-3.2",
    transform: "translate(-50.663 -124.835)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.495,205.518a3.134,3.134,0,1,1-3.1-3.205,3.115,3.115,0,0,1,3.1,3.205",
    transform: "translate(-38.908 -145.161)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.948,70.6a3.1,3.1,0,0,1,3.16,3.137,3.146,3.146,0,0,1-6.291.032,3.1,3.1,0,0,1,3.13-3.169",
    transform: "translate(-30.721 -50.654)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.317,149.414a3.149,3.149,0,1,1-3.187-3.09,3.107,3.107,0,0,1,3.187,3.09",
    transform: "translate(-124.86 -104.988)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.432,111.56a3.109,3.109,0,0,1-3.146,3.156,3.135,3.135,0,0,1-.032-6.269,3.083,3.083,0,0,1,3.179,3.113",
    transform: "translate(-132.127 -77.812)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.944,152.551a3.13,3.13,0,0,1,0-6.26,3.131,3.131,0,1,1,0,6.26",
    transform: "translate(-30.732 -104.965)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.2,111.578a3.136,3.136,0,1,1-3.135-3.172,3.134,3.134,0,0,1,3.135,3.172",
    transform: "translate(-155.647 -77.782)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.883,114.693a3.131,3.131,0,0,1-.1-6.261,3.131,3.131,0,1,1,.1,6.261",
    transform: "translate(-23.492 -77.8)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,165.753a3.14,3.14,0,0,1,6.279.05,3.188,3.188,0,0,1-3.171,3.156,3.139,3.139,0,0,1-3.108-3.206",
    transform: "translate(-145.227 -116.722)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.524,60.4a3.089,3.089,0,0,1-3.107-3.187,3.136,3.136,0,1,1,3.107,3.187",
    transform: "translate(-145.235 -38.83)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.347,45.962a3.133,3.133,0,1,1,3.172,3.118,3.123,3.123,0,0,1-3.172-3.118",
    transform: "translate(-105.005 -30.694)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.867,20.733a3.144,3.144,0,1,1,.048-6.288,3.144,3.144,0,0,1-.048,6.288",
    transform: "translate(-116.762 -10.364)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.584,216.908a3.128,3.128,0,1,1-3.122,3.173,3.079,3.079,0,0,1,3.122-3.173",
    transform: "translate(-77.823 -155.633)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.752,165.8a3.11,3.11,0,0,1-3.143,3.158,3.161,3.161,0,0,1-3.139-3.183,3.12,3.12,0,0,1,3.1-3.079,3.073,3.073,0,0,1,3.181,3.1",
    transform: "translate(-10.382 -116.735)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65,54.251A3.125,3.125,0,0,1,17.7,60.5a3.125,3.125,0,1,1-.051-6.249",
    transform: "translate(-10.403 -38.925)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.718,187.306a3.138,3.138,0,1,1-6.273-.175,3.138,3.138,0,0,1,6.273.175",
    transform: "translate(-77.808 -132.083)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.488,17.568a3.138,3.138,0,0,1-6.276.034,3.138,3.138,0,1,1,6.276-.034",
    transform: "translate(-38.897 -10.329)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.165,114.7a3.137,3.137,0,1,1,0-6.274,3.137,3.137,0,0,1,0,6.274",
    transform: "translate(0 -77.794)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.582,38.962a3.13,3.13,0,1,1,3.157-3.142,3.1,3.1,0,0,1-3.157,3.142",
    transform: "translate(-77.829 -23.465)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.588,0a3.091,3.091,0,0,1,3.137,3.151,3.132,3.132,0,1,1-6.263-.119A3.1,3.1,0,0,1,111.588,0",
    transform: "translate(-77.822 0)",
    fill: "#20e2bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.828,116.213a2.189,2.189,0,0,1-2.2-2.188,2.229,2.229,0,0,1,2.163-2.118,2.153,2.153,0,0,1,.038,4.305",
    transform: "translate(-50.675 -80.295)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6,114.107a2.232,2.232,0,0,1-2.178,2.1,2.153,2.153,0,1,1,2.178-2.1",
    transform: "translate(-110.003 -80.292)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.616,137.791a2.261,2.261,0,0,1,2.235-2.046,2.15,2.15,0,1,1-.21,4.3,2.22,2.22,0,0,1-2.025-2.25",
    transform: "translate(-50.666 -97.397)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.486,88.09a2.2,2.2,0,0,1,2.12,2.264,2.265,2.265,0,0,1-2.247,2.031,2.149,2.149,0,0,1,.127-4.3",
    transform: "translate(-110.006 -63.205)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.46,135.727a2.153,2.153,0,0,1,.05,4.306,2.153,2.153,0,1,1-.05-4.306",
    transform: "translate(-110.008 -97.385)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.912,90.23a2.176,2.176,0,0,1-2.1,2.159,2.153,2.153,0,1,1-.015-4.306,2.168,2.168,0,0,1,2.118,2.147",
    transform: "translate(-50.674 -63.2)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.943,102.268a2.176,2.176,0,0,1-2.1,2.065,2.114,2.114,0,0,1-2.166-2.2,2.072,2.072,0,0,1,2.077-2.058,2.14,2.14,0,0,1,2.185,2.2",
    transform: "translate(-95.198 -71.802)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.765,151.968a2.129,2.129,0,0,1,.011-4.258,2.159,2.159,0,0,1,2.165,2.2,2.124,2.124,0,0,1-2.176,2.055",
    transform: "translate(-95.196 -105.983)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.453,100.084a2.108,2.108,0,0,1,2.161,2.1,2.078,2.078,0,0,1-2.083,2.162,2.13,2.13,0,1,1-.078-4.26",
    transform: "translate(-65.544 -71.811)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,111.91a2.151,2.151,0,1,1-2.138,2.133,2.216,2.216,0,0,1,2.138-2.133",
    transform: "translate(-80.33 -80.296)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.546,128.161a2.141,2.141,0,0,1-2.195-2.187,2.176,2.176,0,0,1,2.087-2.074,2.115,2.115,0,0,1,2.177,2.085,2.08,2.08,0,0,1-2.069,2.176",
    transform: "translate(-65.545 -88.899)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.944,126.063a2.15,2.15,0,0,1-2.073,2.085,2.113,2.113,0,0,1-2.19-2.177,2.079,2.079,0,0,1,2.052-2.084,2.159,2.159,0,0,1,2.211,2.176",
    transform: "translate(-95.199 -88.889)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.254,90.294a2.149,2.149,0,1,1-2.054-2.213,2.217,2.217,0,0,1,2.054,2.213",
    transform: "translate(-80.33 -63.197)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.108,163.858a2.152,2.152,0,1,1,2.144-2.125,2.211,2.211,0,0,1-2.144,2.125",
    transform: "translate(-80.328 -114.482)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.254,137.857a2.148,2.148,0,1,1-2.155-2.12,2.222,2.222,0,0,1,2.155,2.12",
    transform: "translate(-80.33 -97.392)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.254,66.464a2.149,2.149,0,1,1-2.068-2.2,2.216,2.216,0,0,1,2.068,2.2",
    transform: "translate(-80.33 -46.109)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.577,76.281a2.126,2.126,0,0,1-.123,4.25,2.159,2.159,0,0,1-2.109-2.257,2.122,2.122,0,0,1,2.232-1.993",
    transform: "translate(-65.539 -54.73)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.545,147.739a2.128,2.128,0,0,1,2.069,2.187,2.058,2.058,0,0,1-2.167,2.064,2.13,2.13,0,0,1-2.1-2.171,2.18,2.18,0,0,1,2.194-2.08",
    transform: "translate(-65.545 -106.004)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.755,80.511a2.129,2.129,0,0,1-2.074-2.181,2.057,2.057,0,0,1,2.162-2.07,2.128,2.128,0,0,1,2.1,2.166,2.177,2.177,0,0,1-2.189,2.085",
    transform: "translate(-95.199 -54.716)",
    fill: "#9fd983"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6ed55067cb787fab1e6816774657f3a.svg";
export { ForwardRef as ReactComponent };